import { useEffect, useState } from "react";

const NAV_LINKS = [
  { id: "overview", label: "要求速览" },
  { id: "format", label: "格式规范" },
  { id: "word-copyright", label: "字数与原创" },
  { id: "review", label: "审核标准" },
  { id: "process", label: "投稿流程" },
  { id: "faq", label: "常见问题" },
];

function scrollToSection(id: string) {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("overview");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 30);
      const ids = [...NAV_LINKS.map((l) => l.id), "submit"];
      let current = "overview";
      for (const id of ids) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= 120) {
          current = id;
        }
      }
      setActive(current === "submit" ? "submit" : current);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = (id: string) => {
    setOpen(false);
    scrollToSection(id);
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/90 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 md:px-6">
        <a
          href="#overview"
          onClick={(e) => {
            e.preventDefault();
            setOpen(false);
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-2 whitespace-nowrap"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-sm">
            <span className="text-lg leading-none">🍉</span>
          </span>
          <span className="font-display text-xl text-primary-600">吃瓜投稿</span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {NAV_LINKS.map((link) => (
            <button
              key={link.id}
              onClick={() => handleClick(link.id)}
              className={`whitespace-nowrap rounded-full px-3 py-2 text-sm transition-colors ${
                active === link.id
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-800 hover:bg-background-200/60"
              }`}
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            onClick={() => scrollToSection("submit")}
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            立即投稿
          </button>
          <button
            onClick={() => setOpen((v) => !v)}
            aria-label="菜单"
            className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-900 md:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-2xl`}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 md:hidden">
          <nav className="flex flex-col gap-1 pt-3">
            {NAV_LINKS.map((link) => (
              <button
                key={link.id}
                onClick={() => handleClick(link.id)}
                className="flex items-center gap-2 rounded-lg px-3 py-3 text-left text-[15px] text-foreground-800 hover:bg-background-100"
              >
                <span className="h-1.5 w-1.5 rounded-full bg-primary-400"></span>
                {link.label}
              </button>
            ))}
            <button
              onClick={() => handleClick("submit")}
              className="mt-2 flex items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-4 py-3 text-sm text-background-50"
            >
              立即投稿
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}